import axios from "axios";
import { authHeader } from "./authHeader";


const API_URL = process.env.REACT_APP_API_URL;

const PYTON_API_URL = process.env.PYTHON_APP_API_URL || "http://127.0.0.1:4001";

// Create B2B Lead
const createB2bLead = (formData) => {
    const response= axios.post(API_URL + '/api/b2bLead',formData, { headers: authHeader()});
    return response;
}

// Get B2B Lead
const getB2bLead = (params) => {
    const response= axios.get(API_URL + '/api/b2bLead', {
        params: params, 
        headers: authHeader()
    });
    return response;
}

// Get B2B Lead By Id
const getB2bLeadById = (l_id) => {
    const response= axios.get(API_URL + `/api/b2bLead/${l_id}`, {
        headers: authHeader()
    });
    return response;
}

// Update B2B Lead
const updateB2bLead = (l_id, formData) => {
    const response= axios.put(API_URL + `/api/b2bLead/${l_id}`,formData, {
        headers: authHeader()
    });
    return response;
}

// PYTHON API

// Create B2B Lead Template
const createB2bLeadPython = (formData) => {
    const response= axios.post(PYTON_API_URL + '/process-data/',formData, { headers: authHeader()});
    return response;
}

const B2BLEADAPI = {createB2bLead, getB2bLead, getB2bLeadById, updateB2bLead, createB2bLeadPython };

export default B2BLEADAPI;